<template>
    <div class="login-container">
        <UploadHeader colorClass="blue" />
        <div class="slds-p-around_x-large login-wrapper slds-grid slds-grid_vertical slds-grid_vertical-align-center">
            <div class="slds-notify_container slds-is-relative slds-m-bottom_x-large">
                <div
                    v-if="store__loginState.isPermissionDisabled"
                    class="slds-notify slds-notify_toast slds-theme_error"
                >
                    <span class="slds-assistive-text">error</span>
                    <div class="slds-icon_container slds-icon-utility-error slds-m-right_small slds-no-flex slds-align-top">
                        <span class="ma-icon ma-icon-warning ma-icon-large"></span>
                    </div>
                    <div class="slds-notify__content">
                        <h2 class="slds-text-heading_small">
                            We're having trouble logging you in
                        </h2>
                        <p>Please make sure you have the "Manage data sources" permission for Salesforce Maps.</p>
                    </div>
                </div>
            </div>
            <div class="slds-grid slds-p-around_x-large">
                <h1 class="large-header">
                    Let's add new data sources!
                </h1>
            </div>
            <div class="ma-uploader-welcome slds-grid slds-grid_vertical slds-grid_align-center slds-p-around_x-large">
                <div class="slds-grid slds-grid_align-center slds-grid_vertical">
                    <a
                        class="slds-button slds-button_brand slds-button_neutral slds-p-horizontal_xx-large slds-p-vertical_x-small"
                        href="/api/login?sandbox=false"
                    >Login to Production
                    </a>
                    <div>
                        <a
                            class="slds-m-top_large slds-text-align_center slds-grid_align-center slds-button"
                            href="/api/login?sandbox=true"
                        >Login to Sandbox</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex';
import UploadHeader from './UploadHeader.vue';

export default {
    name: 'Login',
    components: {
        UploadHeader
    },
    computed: {
        ...mapState({
            store__loginState: 'loginState'
        })
    }
};
</script>
<style lang="scss">
    .slds-global-header_container{
        position: relative;

        .slds-global-header {
            height: auto;
        }
    }
</style>
<style lang="scss" scoped>

    .slds-global-header__logo {
        background-image: url('../assets/mapanything-logo-white-min.svg');
    }

    .ma-profile-menu .slds-button {
        border-radius: 1rem;
    }

    .ma-uploader-welcome {
        max-width: 22rem;

        .ma-icon-checkin {
            color: #1589F0;
        }
    }

    .login-container {
        display: flex;
        flex-direction: column;
        flex: 2;
        background: #CAE6F1 url(../assets/login-background-image.png) -15vw bottom/125% 60% no-repeat;
    }

    .login-wrapper {
        height: 100%;
    }

    h1 {
        font-size: 2.5em;
        color: #00396B;
    }

</style>
